/*
 * Copyright (c) Nexign, JSC, 2019.
 */
import { PureComponent } from 'react';

import ReactDOM from 'react-dom';

export interface IRenderInBody {
    modalRoot?: HTMLElement;
}

/**
 * @description The class wrapped components and append his to body
 *
 * @author Yakov Gushchin
 * @version 1.0.0
 * @since 1.0.0
 */
class RenderInBody extends PureComponent<IRenderInBody> {

    static defaultProps: {
        appendToBody: true;
    };

    popup: HTMLDivElement;
    modalRoot: HTMLElement;

    constructor(props: IRenderInBody) {
        super(props);
        this.modalRoot = this.props.modalRoot || document.body;
        this.popup = document.createElement('div');
    }

    componentDidMount() {
        this.modalRoot.appendChild(this.popup);
    }

    componentWillUnmount() {
        this.modalRoot.removeChild(this.popup);
    }

    render() {
        return ReactDOM.createPortal(
            this.props.children,
            this.popup,
        );
    }
}

export default RenderInBody;
